// DS1.10.1
// DS1.10.2
// DS1.10.3
import { useReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';
import React from 'react';
import { usePopoverOnInteraction } from '../../../popper/hooks/usePopoverOnInteraction';
import SophisticatedTooltipBase, {
  SophisticatedTooltipBaseProps,
} from '../../lego/SophisticatedTooltipBase';

type Props = Exclude<
  SophisticatedTooltipBaseProps,
  'onReferenceClick' | 'onReferenceMouseEnter' | 'onReferenceMouseLeave'
>;

/**
 * A more sophisticated tooltip than SimpleTooltip. This handles the expected UX for a standard tooltip.
 *
 * If `heading` isn't supplied, `aria-label` is required to fulfill a11y requirements.
 *
 * If you want an FTUE tooltip, consider using `SophisticatedFtueTooltip` instead.
 */
const SophisticatedTooltip: React.FC<Props> = ({ isVisible: forceVisible, ...rest }) => {
  const isForcingVisibility = forceVisible !== undefined;
  const shouldListenForEvents = !isForcingVisibility;
  const { isVisible, onClick, onMouseEnter, onMouseLeave, onClose } = usePopoverOnInteraction({
    listenOnClicks: shouldListenForEvents,
    listenOnHover: shouldListenForEvents,
    hideOnScroll: shouldListenForEvents,
  });

  const reverseTheme = useReverseTheme();

  return isForcingVisibility ? (
    <SophisticatedTooltipBase
      isVisible={forceVisible}
      forceTheme={reverseTheme}
      {...(rest as any)}
    />
  ) : (
    <SophisticatedTooltipBase
      isVisible={isVisible}
      forceTheme={reverseTheme}
      onReferenceClick={onClick}
      onReferenceMouseEnter={onMouseEnter}
      onReferenceMouseLeave={onMouseLeave}
      onClose={onClose}
      {...(rest as any)}
    />
  );
};
SophisticatedTooltip.displayName = 'SophisticatedTooltip';

export default SophisticatedTooltip;
